<script setup lang="ts">
import { ref, computed, inject } from "vue";
import { TranslationService } from "../services/translation.service";

const t = (inject<TranslationService>("translationSvc") as TranslationService)
    .t;

const { items } = defineProps({
    items: {
        type: Array,
        required: true,
    },
});

const openItem = ref("");
</script>

<template>
    <div class="">
        <div
            v-for="(item, index) in items"
            :key="index"
            class="py-4 px-8 bg-white rounded-lg mb-8"
        >
            <div
                class="flex justify-between items-center cursor-pointer"
                @click="openItem = openItem === item.title ? '' : item.title"
            >
                <h3 class="text-f4 font-bold">
                    {{ item.title }}
                </h3>
                <span>
                    <svg
                        v-if="openItem === item.title"
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-6 w-6 transform rotate-180 transition-transform duration-300"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="#009aa7"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M19 9l-7 7-7-7"
                        />
                    </svg>
                    <svg
                        v-else
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-6 w-6 transform transition-transform duration-300"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="#009aa7"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M19 9l-7 7-7-7"
                        />
                    </svg>
                </span>
            </div>
            <div
                v-if="openItem === item.title"
                class="mt-6 text-gray-700 transition-all duration-300 ease-in-out"
            >
                <div class="redactor-content" v-html="item.body"></div>
            </div>
        </div>
    </div>
</template>
